import localScaleManager from "../../../helpers/LocalScaleManager";

export class SeatTimer {
  /***
   * @param scene {GameScene}
   * @param table {Table}
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.time = this.table.tableInfo.turnTime * 1000;
    this.lineBg = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "turn-timer-bg")
      .setOrigin(0)
      .setDepth(13);
    this.table.poolArray.push(this.lineBg);
    this.redLine = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "turn-timer-little")
      .setOrigin(0)
      .setDepth(13);
    this.table.poolArray.push(this.redLine);
    this.line = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "turn-timer")
      .setOrigin(0)
      .setDepth(13);

    this.table.poolArray.push(this.line);

    // this.star = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, "timer-star")
    //   .setDepth(10);
    // this.table.poolArray.push(this.star);

    this.seatBoxWidth = 0;
    this.lineInitScaleX = 1;
    // this.starInitX = 0;
    this.setVisibility(false);
    this.timerInProgress = false;
    this.lineTween = null;
    this.lineInitWidth = 0;

    this.shape = this.scene.make.graphics();
    this.shape.fillStyle(0xffffff);
    this.shape.fillPath();
    this.shape2 = this.scene.make.graphics();
    this.shape2.fillStyle(0xffffff);
    this.shape2.fillPath();

    this.table.poolArray.push(this.shape);
    this.table.poolArray.push(this.shape2);

    this.mask = this.shape.createGeometryMask();
    this.mask2 = this.shape2.createGeometryMask();
    this.table.poolArray.push(this.mask);
    this.table.poolArray.push(this.mask2);

    this.line.setMask(this.mask);
    this.redLine.setMask(this.mask2);

    this.playerId = null;
  }
  setVisibility(visible) {
    if (this.line.visible !== visible) this.line.setVisible(visible);
    if (this.lineBg.visible !== visible) this.lineBg.setVisible(visible);
    if (this.redLine.visible !== visible) this.redLine.setVisible(visible);
    // if (this.star.visible !== visible)this.star.setVisible(visible);
  }
  stopTimer() {
    // this.setVisibility(false);
    // this.line.scaleX = this.lineInitScaleX;
    // this.removeTimerTween();
    // if (this.lineBg.visible) this.lineBg.setVisible(false);
    // this.star.x = this.starInitX;
    // if (this.star.visible) this.star.setVisible(false);
    // this.timerInProgress = false;
    // if (this.lineTween) this.scene.tweens.remove(this.lineTween);
    // if (this.starTween) this.scene.tweens.remove(this.starTween);
    this.setVisibility(false);
    if (this.timerCounter) {
      this.timerCounter.stop();
      this.timerCounter.destroy();
      this.timerCounter = null;
    }
  }
  // removeTimerTween() {
  //   this.setVisibility(false);
  //   // this.timerInProgress = false;
  //   if (this.lineTween) {
  //     this.scene.tweens.remove(this.lineTween);
  //     this.lineTween = null;
  //   }
  // }
  startTimer(time, totalTime, seatBox, playerId) {
    this.stopTimer();
    this.positionControls(
      seatBox.displayWidth,
      seatBox.displayHeight,
      seatBox.x,
      seatBox.y
    );
    this.playerId = playerId;
    this.setVisibility(true);
    if (!this.lineBg.visible) this.lineBg.setVisible(true);
    if (!this.redLine.visible) this.redLine.setVisible(true);

    // if (!this.line.frame.name !== "turn-timer")
    //   this.line.setFrame("turn-timer", false, false);
    // this.line.setAlpha(1);
    this.shape.clear();
    this.shape2.clear();
    const w =
      this.line.displayWidth -
      (this.line.displayWidth * totalTime - time) / totalTime;
    // this.shape.fillStyle(0xffff00, 1);
    // this.shape.setPosition(0, 0);
    this.shape.fillRect(this.line.x, this.line.y, w, this.line.displayHeight);
    this.shape2.fillRect(this.line.x, this.line.y, w, this.line.displayHeight);
    this.shape.fillPath();
    this.shape2.fillPath();
    let shapeAlpha = 0;
    this.timerCounter = this.scene.tweens.addCounter({
      from: totalTime - time,
      to: totalTime,
      duration: time,
      onUpdate: (tween) => {
        let t = tween.getValue();
        this.shape.clear();
        this.shape2.clear();
        if (totalTime - t >= totalTime * 0.75) {
          if (this.line.alpha !== 1) this.line.setAlpha(1);
          if (this.shape.alpha !== 1) this.shape.setAlpha(1);
          if (this.redLine.alpha !== 0) this.redLine.setAlpha(0);
        } else if (totalTime - t <= totalTime * 0.25) {
          if (this.line.alpha !== 0) this.line.setAlpha(0);
          if (this.redLine.alpha !== 1) this.redLine.setAlpha(1);
        } else {
          if (!((1.5 - (2 * t) / totalTime).toFixed(2) == shapeAlpha)) {
            shapeAlpha = (1.5 - (2 * t) / totalTime).toFixed(2);
            this.shape.setAlpha(shapeAlpha);
            this.line.setAlpha(shapeAlpha);
          }
          if (this.redLine.alpha !== 1) this.redLine.setAlpha(1);
        }
        // if(totalTime - t >= totalTime * .5 ){
        //   this.line.setAlpha(1-(t/totalTime));
        // } else {
        //   this.line.setAlpha(1-(t/totalTime))
        //   // if(this.line.alpha !== 1) this.line.setAlpha(1)
        // }
        // if (totalTime - t <= totalTime * 0.5) {
        //   if (!this.line.frame.name !== "turn-timer-little")
        //     this.line.setFrame("turn-timer-little", false, false);
        // }
        // this.shape.fillStyle(0xffff00, 1);
        // this.shape.setPosition(0, 0);
        this.shape.fillRect(
          this.line.x,
          this.line.y,
          this.line.displayWidth - (this.line.displayWidth * t) / totalTime,
          this.line.displayHeight
        );
        this.shape.fillPath();
        this.shape2.fillRect(
          this.line.x,
          this.line.y,
          this.line.displayWidth - (this.line.displayWidth * t) / totalTime,
          this.line.displayHeight
        );
        this.shape2.fillPath();
      },
    });
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY) {
    let lineSize = width * 0.9;
    localScaleManager.scaleSprite(this.line, lineSize, lineSize, 0, 1, true);
    localScaleManager.scaleSprite(this.lineBg, lineSize, lineSize, 0, 1, true);
    localScaleManager.scaleSprite(this.redLine, lineSize, lineSize, 0, 1, true);
    this.line.setPosition(
      initX - this.line.displayWidth / 2,
      initY - this.line.displayHeight / 2
    );
    this.lineBg.setPosition(this.line.x, this.line.y);
    this.redLine.setPosition(this.line.x, this.line.y);
    this.lineInitScaleX = this.line.scaleX;
    this.seatBoxWidth = width;
    this.lineInitWidth = this.line.displayWidth;
    this.shape.fillRect(
      this.line.x,
      this.line.y,
      this.line.displayWidth,
      this.line.displayHeight
    );

    // this.shape.fillPath();

    // this.mask = this.shape.createGeometryMask();

    // this.line.setMask(this.mask);
    // this.redLine.setMask(this.mask);
    // let starSize = width / 5;
    // let starScale = localScaleManager.scaleSprite(
    //   this.star,
    //   starSize,
    //   starSize,
    //   0,
    //   1,
    //   true
    // );
    // localScaleManager.scaleSpriteTo(this.star, starScale);
    // this.star.setPosition(this.line.x + this.line.displayWidth, this.line.y);
    // this.starInitX = this.star.x;
    // this.startTimer(15000, 20000);
  }
  reposition(width, height, initX, initY) {
    this.line.setPosition(
      initX - this.line.displayWidth / 2,
      initY - this.line.displayHeight / 2
    );
    this.lineBg.setPosition(this.line.x, this.line.y);
    this.redLine.setPosition(this.line.x, this.line.y);
  }
  remove() {
    this.line.destroy();
    // this.star.destroy();
  }
}
